import React, { useState, useEffect } from 'react';
import client, { API_URL, APP_VERSION } from '../api/client';

const HealthCheckView = ({ darkMode, styles }) => {
    const [health, setHealth] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        client.get('/health')
            .then(res => setHealth(res.data))
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    }, []);

    if (loading) return <div style={{padding: '40px', textAlign: 'center'}}>시스템 상태 확인 중...</div>;
    if (!health) return <div style={{padding: '40px', textAlign: 'center'}}>상태 정보를 불러올 수 없습니다.</div>;

    return (
        <div style={{padding: '0 0 80px 0', color: darkMode ? '#fff' : '#000'}}>
            <h2 style={{fontSize: '20px', marginBottom: '20px', color: darkMode ? '#fff' : '#333'}}>시스템 상태</h2>
            
            <div style={{marginBottom: '20px', padding: '15px', borderRadius: '15px', backgroundColor: darkMode ? '#333' : '#f5f5f5', boxShadow: '0 2px 5px rgba(0,0,0,0.05)'}}>
                <h3 style={{fontSize: '16px', marginBottom: '10px'}}>데이터베이스</h3>
                <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <div style={{width: '10px', height: '10px', borderRadius: '50%', backgroundColor: health.database === 'connected' ? '#4caf50' : '#f44336'}}></div>
                    <span>{health.database === 'connected' ? '정상 연결됨' : '연결 오류'}</span>
                </div>
            </div>

            <div style={{marginBottom: '20px', padding: '15px', borderRadius: '15px', backgroundColor: darkMode ? '#333' : '#f5f5f5', boxShadow: '0 2px 5px rgba(0,0,0,0.05)'}}>
                <h3 style={{fontSize: '16px', marginBottom: '10px'}}>디스크 사용량 (서버)</h3>
                <div>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '5px', fontSize: '14px'}}>
                        <span>사용됨: {(health.disk.used / 1024 / 1024 / 1024).toFixed(2)} GB</span>
                        <span>총량: {(health.disk.total / 1024 / 1024 / 1024).toFixed(2)} GB</span>
                    </div>
                    <div style={{width: '100%', height: '10px', backgroundColor: '#ddd', borderRadius: '5px', overflow: 'hidden'}}>
                        <div style={{width: `${health.disk.percent}%`, height: '100%', backgroundColor: health.disk.percent > 90 ? '#f44336' : '#2196f3'}}></div>
                    </div>
                    <div style={{textAlign: 'right', fontSize: '12px', marginTop: '5px'}}>{health.disk.percent.toFixed(1)}% 사용 중</div>
                </div>
            </div>

            <div style={{marginBottom: '20px', padding: '15px', borderRadius: '15px', backgroundColor: darkMode ? '#333' : '#f5f5f5', boxShadow: '0 2px 5px rgba(0,0,0,0.05)'}}>
                <h3 style={{fontSize: '16px', marginBottom: '10px'}}>업로드 파일</h3>
                <div style={{fontSize: '14px'}}>
                    <p>총 파일 수: {health.uploads.file_count}개</p>
                    <p>총 용량: {(health.uploads.size_bytes / 1024 / 1024).toFixed(2)} MB</p>
                </div>
            </div>

            <div style={{marginBottom: '20px', padding: '15px', borderRadius: '15px', backgroundColor: darkMode ? '#333' : '#f5f5f5', boxShadow: '0 2px 5px rgba(0,0,0,0.05)'}}>
                <h3 style={{fontSize: '16px', marginBottom: '10px'}}>앱 버전</h3>
                <div style={{fontSize: '14px'}}>
                    <p>Frontend: {APP_VERSION}</p>
                    <p>Backend: {health.version}</p>
                </div>
            </div>
        </div>
    );
};

export default HealthCheckView;
